/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import * as React from 'react';
import { connect } from 'react-redux';
import {Field} from 'redux-form';
import { CheckboxField } from 'src/js/components/form/CheckboxField';
import { IshState } from 'src/js/services/IshState';
import {TextField} from 'src/js/components/form/TextField';
import {scrollToTop} from 'src/js/common/utils/DomUtils';
import {replaceWithNl} from 'src/js/common/utils/HtmlUtils';

export interface Props {
  contactDetailsEditable?: boolean;
  header?: string;
}

class ContactAddBase extends React.Component<Props, any> {
  componentDidMount() {
    scrollToTop();
  }

  render() {
    const {contactDetailsEditable, header = 'Enter the person who will attend the class or make a purchase.'} = this.props;
    return (
      <div id="addstudent-block">
        <div className="message">
          <p style={{whiteSpace: 'pre-line'}}>{replaceWithNl(header)}</p>
        </div>
        <fieldset className="field-wrapper contact-add-wrapper">
          <Field
             component={TextField}
             autocomplete="given-name"
             name="firstName"
             label="First name"
             type="text"
             autoFocus
             required
          />
          <Field
             component={TextField}
             autocomplete="family-name"
             name="lastName"
             label="Last name"
             type="text"
             required
          />
          <Field
             component={TextField}
             autocomplete="email"
             name="email"
             label="Email"
             type="email"
             required
          />
        </fieldset>
        <p className="note">
          <strong className="alert">Note:</strong> If you have been here before, please try to use the same email
          address.
        </p>

        {contactDetailsEditable && <>
          <h2>Details update</h2>
          <div className="message">Been here before? Would you like to update your details on the next step?</div>

          <fieldset className="field-wrapper contact-updateData-wrapper">
            <Field
              component={CheckboxField}
              name="updateData"
              label="Update my data"
            />
          </fieldset>
        </>}
      </div>
    );
  }
}

const mapStateToProps = (state: IshState) => ({
  contactDetailsEditable: state.preferences.contactDetailsEditable
});

export const ContactAdd = connect<any, any, any, IshState>(mapStateToProps)(ContactAddBase);
